import t from "react";
import { v1 as e } from "uuid";
const s = () => {
  const { current: r } = t.useRef(e());
  return r;
};
export {
  s as u
};
